import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { TrustRow } from "@/components/TrustRow";
import { Capabilities } from "@/components/Capabilities";
import { Divisions } from "@/components/Divisions";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Stats } from "@/components/Stats";
import { Process } from "@/components/Process";
import { AcademyWaitlist } from "@/components/AcademyWaitlist";
import { FAQ } from "@/components/FAQ";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Testimonials } from "@/components/Testimonials";
import { Industries } from "@/components/Industries";
import { ContentProvider } from "@/content";

export default function Site() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <ContentProvider>
      <div className="min-h-screen bg-[#F8FAFC] text-[#0B1528]" data-testid="app-root">
        <div className="grain-overlay" />
        <ScrollProgress onTop={() => scrollTo("home")} />
        <Nav onNavigate={scrollTo} />
        <main>
          <Hero onNavigate={scrollTo} />
          <Marquee />
          <TrustRow />
          <Stats />
          <Capabilities onNavigate={scrollTo} />
          <Industries />
          <Process />
          <Testimonials />
          <Divisions onNavigate={scrollTo} />
          <AcademyWaitlist />
          <About />
          <FAQ />
          <Contact />
        </main>
        <Footer onNavigate={scrollTo} />
      </div>
    </ContentProvider>
  );
}
